var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ttsApiClient as apiClient } from './apiClient';
var ProgressTrackingService = /** @class */ (function () {
    function ProgressTrackingService() {
        this.getToken = null;
        this.baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    }
    ProgressTrackingService.prototype.setTokenProvider = function (getToken) {
        this.getToken = getToken;
    };
    ProgressTrackingService.prototype.makeRequest = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var token, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = null;
                        if (!this.getToken) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        _a.label = 2;
                    case 2:
                        config = {
                            url: url,
                            method: options.method || 'GET',
                            data: options.body ? JSON.parse(options.body) : undefined,
                            headers: __assign({ 'Content-Type': 'application/json' }, (token && { Authorization: "Bearer ".concat(token) })),
                        };
                        return [4 /*yield*/, apiClient(config)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    // ================================================
    // Learning Sessions
    // ================================================
    ProgressTrackingService.prototype.startLearningSession = function (nodeId, sessionType, config) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest('/api/progress/sessions', {
                            method: 'POST',
                            body: JSON.stringify({
                                node_id: nodeId,
                                session_type: sessionType,
                                activity_reference_id: config === null || config === void 0 ? void 0 : config.activityReferenceId,
                                activity_reference_type: config === null || config === void 0 ? void 0 : config.activityReferenceType,
                                device_type: config === null || config === void 0 ? void 0 : config.deviceType,
                                study_environment: config === null || config === void 0 ? void 0 : config.studyEnvironment,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.session_id];
                }
            });
        });
    };
    ProgressTrackingService.prototype.completeLearningSession = function (sessionId, results) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/sessions/".concat(sessionId, "/complete"), {
                            method: 'PUT',
                            body: JSON.stringify({
                                items_attempted: results.itemsAttempted,
                                items_completed: results.itemsCompleted,
                                items_correct: results.itemsCorrect,
                                session_score: results.sessionScore,
                                focus_rating: results.focusRating,
                                difficulty_rating: results.difficultyRating,
                                confidence_change: results.confidenceChange,
                                completion_reason: results.completionReason,
                                session_notes: results.sessionNotes,
                                ended_at: results.endedAt,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getUserSessions = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        if (options === null || options === void 0 ? void 0 : options.nodeId)
                            params.append('node_id', options.nodeId);
                        if (options === null || options === void 0 ? void 0 : options.sessionType)
                            params.append('session_type', options.sessionType);
                        if (options === null || options === void 0 ? void 0 : options.limit)
                            params.append('limit', options.limit.toString());
                        return [4 /*yield*/, this.makeRequest("/api/progress/sessions?".concat(params.toString()))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.sessions];
                }
            });
        });
    };
    // ================================================
    // Node Progress
    // ================================================
    ProgressTrackingService.prototype.getNodeProgress = function (nodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/nodes/".concat(nodeId, "/progress"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                node_id: nodeId,
                                user_id: response.progress.user_id,
                                progress: response.progress,
                                analytics: response.analytics,
                                created_at: response.progress.created_at,
                                updated_at: response.progress.updated_at,
                            }];
                }
            });
        });
    };
    ProgressTrackingService.prototype.updateNodePreferences = function (nodeId, preferences) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/nodes/".concat(nodeId, "/preferences"), {
                            method: 'PUT',
                            body: JSON.stringify({
                                is_bookmarked: preferences.isBookmarked,
                                priority_level: preferences.priorityLevel,
                                target_mastery_level: preferences.targetMasteryLevel,
                                target_completion_date: preferences.targetCompletionDate,
                                custom_notes: preferences.customNotes,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getProgressSummary = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest('/api/progress/progress/summary')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.progress_summary];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getMultipleNodeProgress = function (nodeIds) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest('/api/progress/nodes/batch', {
                            method: 'POST',
                            body: JSON.stringify({ node_ids: nodeIds }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.progress_data];
                }
            });
        });
    };
    // ================================================
    // Flashcard Progress
    // ================================================
    ProgressTrackingService.prototype.updateFlashcardProgress = function (flashcardId, progressData) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/flashcards/".concat(flashcardId), {
                            method: 'PUT',
                            body: JSON.stringify({
                                difficulty_rating: progressData.difficultyRating,
                                confidence_level: progressData.confidenceLevel,
                                review_time_seconds: progressData.reviewTimeSeconds,
                                is_correct: progressData.isCorrect,
                                learning_session_id: progressData.learningSessionId,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.flashcard_progress];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getFlashcardProgress = function (flashcardId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/flashcards/".concat(flashcardId))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.flashcard_progress];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getFlashcardsDueForReview = function (nodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = nodeId ? "?node_id=".concat(nodeId) : '';
                        return [4 /*yield*/, this.makeRequest("/api/progress/flashcards/due".concat(params))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.due_flashcards];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getUserFlashcardProgress = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        if (options === null || options === void 0 ? void 0 : options.nodeId)
                            params.append('node_id', options.nodeId);
                        if (options === null || options === void 0 ? void 0 : options.limit)
                            params.append('limit', options.limit.toString());
                        if (options === null || options === void 0 ? void 0 : options.masteryLevel)
                            params.append('mastery_level', options.masteryLevel);
                        return [4 /*yield*/, this.makeRequest("/api/progress/flashcards?".concat(params.toString()))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.flashcard_progress];
                }
            });
        });
    };
    // ================================================
    // Quiz Progress
    // ================================================
    ProgressTrackingService.prototype.recordQuizProgress = function (sessionQuizId, progressData) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/quizzes/".concat(sessionQuizId), {
                            method: 'PUT',
                            body: JSON.stringify({
                                total_questions: progressData.totalQuestions,
                                questions_answered: progressData.questionsAnswered,
                                correct_answers: progressData.correctAnswers,
                                session_score: progressData.sessionScore,
                                total_time_seconds: progressData.totalTimeSeconds,
                                difficulty_level: progressData.difficultyLevel,
                                is_completed: progressData.isCompleted,
                                completion_mode: progressData.completionMode,
                                learning_session_id: progressData.learningSessionId,
                                user_rating: progressData.userRating,
                                user_notes: progressData.userNotes,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.quiz_progress];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getQuizProgress = function (sessionQuizId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/quizzes/".concat(sessionQuizId))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.quiz_progress];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getUserQuizProgress = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        if (options === null || options === void 0 ? void 0 : options.nodeId)
                            params.append('node_id', options.nodeId);
                        if (options === null || options === void 0 ? void 0 : options.limit)
                            params.append('limit', options.limit.toString());
                        if (options === null || options === void 0 ? void 0 : options.difficultyLevel)
                            params.append('difficulty_level', options.difficultyLevel);
                        return [4 /*yield*/, this.makeRequest("/api/progress/quizzes?".concat(params.toString()))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.quiz_progress];
                }
            });
        });
    };
    // ================================================
    // User Goals
    // ================================================
    ProgressTrackingService.prototype.createGoal = function (goalData) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest('/api/progress/goals', {
                            method: 'POST',
                            body: JSON.stringify({
                                goal_name: goalData.goalName,
                                goal_type: goalData.goalType,
                                target_value: goalData.targetValue,
                                target_unit: goalData.targetUnit,
                                node_id: goalData.nodeId,
                                goal_description: goalData.goalDescription,
                                target_date: goalData.targetDate,
                                priority_level: goalData.priorityLevel,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.goal_id];
                }
            });
        });
    };
    ProgressTrackingService.prototype.updateGoal = function (goalId, updateData) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/goals/".concat(goalId), {
                            method: 'PUT',
                            body: JSON.stringify(updateData),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.goal];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getUserGoals = function (nodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = nodeId ? "?node_id=".concat(nodeId) : '';
                        return [4 /*yield*/, this.makeRequest("/api/progress/goals".concat(params))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.goals];
                }
            });
        });
    };
    ProgressTrackingService.prototype.deleteGoal = function (goalId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/goals/".concat(goalId), {
                            method: 'DELETE',
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                }
            });
        });
    };
    // ================================================
    // Analytics and Reporting
    // ================================================
    ProgressTrackingService.prototype.getUserAnalytics = function (timeRange) {
        if (timeRange === void 0) { timeRange = '30d'; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/analytics?range=".concat(timeRange))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.analytics];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getNodeAnalytics = function (nodeId, timeRange) {
        if (timeRange === void 0) { timeRange = '30d'; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest("/api/progress/nodes/".concat(nodeId, "/analytics?range=").concat(timeRange))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.analytics];
                }
            });
        });
    };
    ProgressTrackingService.prototype.getStreakData = function (nodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = nodeId ? "?node_id=".concat(nodeId) : '';
                        return [4 /*yield*/, this.makeRequest("/api/progress/streaks".concat(params))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.streak_data];
                }
            });
        });
    };
    // ================================================
    // Backward Compatibility Methods
    // ================================================
    ProgressTrackingService.prototype.getOrCreateNodeProgress = function (nodeId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getNodeProgress(nodeId)];
            });
        });
    };
    ProgressTrackingService.prototype.updateProgress = function (nodeId, progressData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.updateNodePreferences(nodeId, {
                        isBookmarked: progressData.is_bookmarked,
                        priorityLevel: progressData.priority_level,
                        targetMasteryLevel: progressData.target_mastery_level,
                        customNotes: progressData.custom_notes,
                    })];
            });
        });
    };
    ProgressTrackingService.prototype.updateNodeProgress = function (nodeId, progressData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateNodePreferences(nodeId, {
                            isBookmarked: progressData.is_bookmarked,
                            priorityLevel: progressData.priority_level,
                            targetMasteryLevel: progressData.target_mastery_level,
                            customNotes: progressData.custom_notes,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.getNodeProgress(nodeId)];
                }
            });
        });
    };
    return ProgressTrackingService;
}());
export var progressTrackingService = new ProgressTrackingService();
export default progressTrackingService;
